/** F.5.8 + F.5.9 — Preco + Desconto use case impls. */
import type { PrecoGateway } from '@/application/port/out/PrecoGateway';
import type { DescontoGateway } from '@/application/port/out/DescontoGateway';
import type { Preco, PrecoCommand } from '@/domain/model/Preco';
import type { Desconto, DescontoSubtipo, CupomStatus, CriarDescontoCommand } from '@/domain/model/Desconto';
import type { Page } from '@/domain/model/Page';
import type { PrecoMeioPagamento, PrecoMeioCommand } from '@/domain/model/PrecoMeio';
import type {
  ListPrecosUseCase, GetPrecoUseCase, CriarPrecoUseCase, AtualizarPrecoUseCase, InativarPrecoUseCase,
  ListPrecoMeiosUseCase, AddPrecoMeioUseCase, RemovePrecoMeioUseCase,
} from '@/application/port/in/PrecoUseCase';
import type {
  ListDescontosUseCase, GetDescontoUseCase, CriarDescontoUseCase,
  AtivarDescontoUseCase, DesativarDescontoUseCase,
} from '@/application/port/in/DescontoUseCase';

export class ListPrecos implements ListPrecosUseCase {
  constructor(private readonly gw: PrecoGateway) {}
  execute(p: { ativo?: boolean; page?: number; size?: number }): Promise<Page<Preco>> { return this.gw.list(p); }
}
export class GetPreco implements GetPrecoUseCase {
  constructor(private readonly gw: PrecoGateway) {}
  execute(id: string): Promise<Preco> { return this.gw.get(id); }
}
export class CriarPreco implements CriarPrecoUseCase {
  constructor(private readonly gw: PrecoGateway) {}
  execute(c: PrecoCommand): Promise<Preco> { return this.gw.criar(c); }
}
export class AtualizarPreco implements AtualizarPrecoUseCase {
  constructor(private readonly gw: PrecoGateway) {}
  execute(id: string, c: PrecoCommand): Promise<Preco> { return this.gw.atualizar(id, c); }
}
export class InativarPreco implements InativarPrecoUseCase {
  constructor(private readonly gw: PrecoGateway) {}
  execute(id: string): Promise<void> { return this.gw.inativar(id); }
}
export class ListPrecoMeios implements ListPrecoMeiosUseCase {
  constructor(private readonly gw: PrecoGateway) {}
  execute(precoId: string): Promise<PrecoMeioPagamento[]> { return this.gw.listMeios(precoId); }
}
export class AddPrecoMeio implements AddPrecoMeioUseCase {
  constructor(private readonly gw: PrecoGateway) {}
  execute(precoId: string, c: PrecoMeioCommand): Promise<PrecoMeioPagamento> { return this.gw.addMeio(precoId, c); }
}
export class RemovePrecoMeio implements RemovePrecoMeioUseCase {
  constructor(private readonly gw: PrecoGateway) {}
  execute(precoId: string, meioId: string): Promise<void> { return this.gw.removeMeio(precoId, meioId); }
}

export class ListDescontos implements ListDescontosUseCase {
  constructor(private readonly gw: DescontoGateway) {}
  execute(p: { subtipo?: DescontoSubtipo; status?: CupomStatus; page?: number; size?: number }): Promise<Page<Desconto>> { return this.gw.list(p); }
}
export class GetDesconto implements GetDescontoUseCase {
  constructor(private readonly gw: DescontoGateway) {}
  execute(id: string): Promise<Desconto> { return this.gw.get(id); }
}
export class CriarDesconto implements CriarDescontoUseCase {
  constructor(private readonly gw: DescontoGateway) {}
  execute(c: CriarDescontoCommand): Promise<Desconto> { return this.gw.criar(c); }
}
export class AtivarDesconto implements AtivarDescontoUseCase {
  constructor(private readonly gw: DescontoGateway) {}
  execute(id: string): Promise<Desconto> { return this.gw.ativar(id); }
}
export class DesativarDesconto implements DesativarDescontoUseCase {
  constructor(private readonly gw: DescontoGateway) {}
  execute(id: string): Promise<Desconto> { return this.gw.desativar(id); }
}
